/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-23 10:15:10
 * @name: 工单管理-发货人修改物流单号
 * @Description: 工单管理-发货人修改物流单号
 * @FilePath: \project\src\module\issue\validator\editTransport.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'com',
    description: '公司代码',
    required: true,
    required_message: '请选择物流公司',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请选择物流公司';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'express_no',
    description: '物流单号',
    required: true,
    required_message: '请输入物流单号',
    require_toast: true,
    match: (e) => {
      if (!e) {
        return '请输入物流单号';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
]